<mat-toolbar>
  <span><a [routerLink]="['/data/device-attribute']" translate>DEVICE_ATTRIBUTES</a>&nbsp;</span>
  <span> / {{item && item.name ? item.name : 'New'}}</span>
  <span class="toolbar-spacer"></span>
  @if (item && item.id) {
    <button mat-raised-button color="warn" (click)="onDeleteAttributeClick()">Delete attribute</button>
  }
  <button mat-raised-button color="primary" (click)="saveItem()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

@if (item) {
  <div class="row my-3">
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Attribute name</mat-label>
        <input type="text" matInput [(ngModel)]="item.name" required>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <app-select-search label="Type" [list]="types" [model]="item.type" (modelChanged)="item.type = $event;" [isRequired]="true"></app-select-search>
    </div>
    @if (item.id ) {
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label>Módosította</mat-label>
          <input type="text" matInput [(ngModel)]="item.modifiedBy" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
    @if (item.id ) {
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label>Módosítva</mat-label>
          <input type="text" matInput [(ngModel)]="item.modified" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
  </div>
}
